<template>
  <div class="common-box text-center">
    <p class="text-left little-title">{{ $t('MyInvitationCode') }}</p>
    <div class="main-info">
      <p class="invite-code">{{ $t('invitationCode') }}<span>{{ invitationCode }}</span></p>
      <div class="invite-url-box"><span class="url">{{ invitation_url }}</span>
        <span class="copy" @click="copyComplete" v-clipboard:copy="invitation_url" :title="$t('clickCopy')">{{ $t('copy') }}</span>
        <transition name="copy">
          <span class="copy-complete" v-show="copied">{{ $t('copySuccess') }}</span>
        </transition>
      </div>
      <p class="describe">{{ $t('commissionExplanation') }}</p>

    </div>
  </div>
</template>

<script>
  import locales from './lang'
  import { mapState } from 'vuex'

  export default {
    name: 'invite-view',
    props: {
      invitationCode: {}
    },
    data: function () {
      return {
        copied: false
      }
    },
    locales,
    computed: {
      invitation_url: function () {
        let inviteHost = window.location.href.match(/(\S*)\//)[1]
        return inviteHost + '?invite_code=' + this.invitationCode
      },
      ...mapState({
        user: state => state.user
      })
    },
    methods: {
      toggle: function (item) {
        item.show = !item.show
      },
      copyComplete: function () {
        this.copied = !this.copied
        setTimeout(() => {
          this.copied = false
        }, 2)
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/variables";

  $base-spacing: .15rem;

  .copy-enter-active, .copy-leave-active {
    animation: copy .8s;
  }

  @keyframes copy {
    0% {
      opacity: 0
    }
    100% {
      opacity: 1
    }
  }

  .common-box {

    .little-title {
      font-size: .16rem;
      line-height: .48rem;
      height: .48rem;
      padding: 0 .16rem;
      border-bottom: 1px solid #E0D7E3;
      color:#111;
      margin-bottom: .24rem;
    }

    .main-info {
      margin: 0 auto;
      padding: 0 .16rem;
      .describe {
        margin-top: 0.24rem;
        font-size: .14rem;
        color:#666;
        letter-spacing: 0;
        line-height: 20px;
      }
      .invite-code {
        margin-bottom: .24rem;
        color:#666;
        font-size: .12rem;
        line-height: 18px;
        span:nth-child(1) {
          font-size: .18rem;
          line-height: .18rem;
          color: #F76B4C;
          font-weight: 500;
        }
      }
      .invite-url-box {
        line-height: 10px;
        position: relative;
        .url {
          line-height: .28rem;
          padding: 0 0.12rem;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow-x: hidden;
          display: inline-block;
          width: calc(100% - 0.54rem - 0.1rem);
          background: rgba(255, 255, 255, 0.1);
          border: 1px solid #e0d7e3;
          border-radius: 14px;
          color: #666;
          font-size: 12px;
        }
        .copy {
          float: right;
          width: 0.54rem;
          line-height: .28rem;
          background: #F15A66;
          border-radius: 14px;
          color: white;
          cursor: pointer;
          font-size: 12px;
        }
        .copy-complete {
          clear: both;
          text-align: center;
          opacity: 0;
          font-size: 16px;
          border-radius: 0.05rem;
          color: #333;
          line-height: 0.24rem;
          background-color: #fff;
          box-shadow: 0px 2px 12px 0px rgba(153,153,153,0.24);
          position: absolute;
          top: -0.6rem;
          right: -5%;
          padding: 0.1rem 0.16rem;
        }
      }
      button {
        color: #61687a;
        margin-top: .12rem;
        min-width: 2rem;
        height: .42rem;
        line-height: .42rem;
        padding: 0 .2rem;
        background: transparent;
        border: 1px solid $gray-dark;
      }
    }
  }

  @media screen and (max-width: 767px) {
    .common-box {
      .little-title {
        font-size: 14px;
        line-height: .44rem;
        height: 0.44rem;
        margin-bottom: .24rem;
      }
      .main-info {
        .invite-url-box {
          width: 100%;
          text-align: left;
          .copy {
            text-align: center;
            display: block;
            top: -.4rem;
            right: 0;
          }
        }
        .describe {
          margin: 16px 0 0;
        }
      }
    }
  }

  @media screen and (min-width: 1920px) {
    .common-box {
      .main-info {
        max-width: 760px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// InviteFriend.vue?b8bc183e